import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { isEmpty } from 'lodash';
import { GET_USER_FABRIC_FAVORITES } from 'mocks/queries';
import { ADD_TO_USER_FABRIC_FAVS, REMOVE_FABRIC_FROM_USER_FABRIC_FAVS } from 'mocks/mutations';
import useUserData from 'data-hooks/useUserData';
import useAllOptions from 'data-hooks/useAllOptions';
import useIsLoggedInCallback from 'data-hooks/useUserData/useIsLoggedInCallback';
const DEFAULT_USER_FABRIC_FAVS = {};
const DEFAULT_FABRIC_FAVS_INFO = {};
const useFabricFavs = t0 => {
  const $ = _c(27);
  const {
    loadMaterialDetails
  } = t0 === undefined ? {} : t0;
  const {
    allOptionsValues
  } = useAllOptions();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      ssr: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    loading,
    data: userFabricFavs,
    refetch
  } = useQuery(GET_USER_FABRIC_FAVORITES, t1);
  const {
    isLoggedIn,
    userId
  } = useUserData();
  const updateUserFav = _temp;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      update(cache_0, t3) {
        const {
          data
        } = t3;
        const favs = data.userFabricFavs;
        Object.keys(favs).forEach(key => key === "undefined" && delete favs[key]);
        updateUserFav(cache_0, favs, "add");
      }
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [addToUserFabricFavorites] = useMutation(ADD_TO_USER_FABRIC_FAVS, t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      update(cache_1, t4) {
        const {
          data: data_0
        } = t4;
        const favs_0 = data_0.userFabricFavs;
        Object.keys(favs_0).forEach(key_0 => key_0 === "undefined" && delete favs_0[key_0]);
        updateUserFav(cache_1, favs_0, "remove");
      }
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const [removeFromUserFabricFavorites] = useMutation(REMOVE_FABRIC_FROM_USER_FABRIC_FAVS, t3);
  useIsLoggedInCallback(refetch);
  userFabricFavs?.userFabricFavs;
  let t4;
  bb0: {
    if (!loadMaterialDetails || isEmpty(userFabricFavs?.userFabricFavs) || isEmpty(allOptionsValues)) {
      t4 = DEFAULT_FABRIC_FAVS_INFO;
      break bb0;
    }
    let favFabricsInfoTemp;
    if ($[3] !== allOptionsValues || $[4] !== userFabricFavs?.userFabricFavs) {
      favFabricsInfoTemp = {};
      let t5;
      if ($[6] !== userFabricFavs?.userFabricFavs) {
        t5 = Object.keys(userFabricFavs?.userFabricFavs);
        $[6] = userFabricFavs?.userFabricFavs;
        $[7] = t5;
      } else {
        t5 = $[7];
      }
      for (const key_1 of t5) {
        if (!isEmpty(allOptionsValues[key_1])) {
          favFabricsInfoTemp[key_1] = {
            ...allOptionsValues[key_1],
            materialId: key_1
          };
        }
      }
      $[3] = allOptionsValues;
      $[4] = userFabricFavs?.userFabricFavs;
      $[5] = favFabricsInfoTemp;
    } else {
      favFabricsInfoTemp = $[5];
    }
    t4 = favFabricsInfoTemp;
  }
  const fabricFavsInfo = t4;
  let t5;
  if ($[8] !== addToUserFabricFavorites || $[9] !== isLoggedIn || $[10] !== userFabricFavs || $[11] !== userId) {
    t5 = async optionId => {
      if (userFabricFavs?.[optionId]) {
        return;
      }
      if (!isLoggedIn) {
        addToUserFabricFavorites({
          variables: {
            materialId: optionId
          }
        });
        return;
      }
      addToUserFabricFavorites({
        variables: {
          userId,
          materialId: optionId
        }
      });
    };
    $[8] = addToUserFabricFavorites;
    $[9] = isLoggedIn;
    $[10] = userFabricFavs;
    $[11] = userId;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const setOptionAsFav = t5;
  let t6;
  if ($[13] !== isLoggedIn || $[14] !== removeFromUserFabricFavorites || $[15] !== userId) {
    t6 = async optionId_0 => {
      if (!isLoggedIn) {
        removeFromUserFabricFavorites({
          variables: {
            materialId: optionId_0
          }
        });
        return;
      }
      removeFromUserFabricFavorites({
        variables: {
          userId,
          materialId: optionId_0
        }
      });
    };
    $[13] = isLoggedIn;
    $[14] = removeFromUserFabricFavorites;
    $[15] = userId;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const removeOptionAsFav = t6;
  const t7 = loading ? DEFAULT_USER_FABRIC_FAVS : userFabricFavs?.userFabricFavs;
  let t8;
  if ($[17] !== fabricFavsInfo || $[18] !== isLoggedIn || $[19] !== t7) {
    t8 = {
      userFabricFavs: t7,
      isUserLoggedIn: isLoggedIn,
      fabricFavsInfo
    };
    $[17] = fabricFavsInfo;
    $[18] = isLoggedIn;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== removeOptionAsFav || $[22] !== setOptionAsFav) {
    t9 = {
      setOptionAsFav,
      removeOptionAsFav
    };
    $[21] = removeOptionAsFav;
    $[22] = setOptionAsFav;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t8 || $[25] !== t9) {
    t10 = {
      data: t8,
      actions: t9
    };
    $[24] = t8;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
};
export default useFabricFavs;
function _temp(cache, updatedFabricFavData, action) {
  const existingUserFavs = cache.readQuery({
    query: GET_USER_FABRIC_FAVORITES
  });
  if (existingUserFavs && updatedFabricFavData) {
    cache.writeQuery({
      query: GET_USER_FABRIC_FAVORITES,
      data: {
        userFabricFavs: {
          ...updatedFabricFavData,
          ...(action === "add" && Object.keys(existingUserFavs.userFabricFavs).length && existingUserFavs.userFabricFavs)
        }
      }
    });
  }
}